import { render, staticRenderFns } from "./LicenseSelector.vue?vue&type=template&id=542b49e6&scoped=true&"
import script from "./LicenseSelector.vue?vue&type=script&lang=js&"
export * from "./LicenseSelector.vue?vue&type=script&lang=js&"
import style0 from "./LicenseSelector.vue?vue&type=style&index=0&id=542b49e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b49e6",
  null
  
)

export default component.exports